import { Guid } from "cms-infrastructure-javascriptextensions/Guid";
import { LogItem } from "./LogItem";
import { LogType } from "./LogType";
import { LogLevel } from "./LogLevel";
/**
 * Represents a log item for a network activity.
 * @class
 */
export class NetworkActivityLogItem extends LogItem {
    /**
     * Initializes a new instance of the `NetworkActivityLogItem` class.
     * @constructor
     * @param name {string}  The name of the activity.
     * @param serviceName {string} The name of the service being called.
     * @param requestUri? {string} The URI for the request.
     * @param requestHttpMethod? {string} The HTTP method of the request.
     * @param currentOperationName? {string} The name of the current operation.
     * @param correlationVector? {string} The correlation vector.
     * @param parentActivityId? {string} Parent activity id.
     * @param data {any} Any additional JSON data.
     */
    constructor(name, serviceName, requestUri, requestHttpMethod, currentOperationName, correlationVector, parentActivityId, data) {
        super(name, data, LogType.BeginNetworkActivity, Guid.newGuid(), new Date(), parentActivityId);
        this.serviceName = serviceName;
        this.LogLevel = LogLevel.Activity;
        this.Ended = false;
        this.requestUri = requestUri;
        this.requestHttpMethod = requestHttpMethod;
        this.currentOperationName = currentOperationName;
        this.correlationVector = correlationVector;
    }
}
//# sourceMappingURL=NetworkActivityLogItem.js.map